const PIXEL_ID = "925466493823013";

export const initPixel = () => {
  if (window.fbq) return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    t = b.createElement(e);
    t.async = true;
    t.src = v;

    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js",
  );

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

// Normalize Bangladesh phone numbers to 8801XXXXXXXXX
const normalizePhoneBD = (phone) => {
  if (!phone) return null;

  // remove all non-digits
  let cleaned = phone.replace(/\D/g, "");

  if (cleaned.startsWith("01")) {
    return "880" + cleaned.slice(1);
  }

  if (cleaned.startsWith("880")) {
    return cleaned;
  }

  return null; // unknown format → skip
};

export const setAdvancedMatching = (user) => {
  if (!window.fbq || !user) return;

  const data = {};

  if (user.email) {
    data.em = user.email;
  }

  if (user.mobileNo) {
    const normalizedPhone = normalizePhoneBD(user.mobileNo);
    if (normalizedPhone) {
      data.ph = normalizedPhone;
    }
  }

  if (user.displayName) {
    data.fn = user.displayName;
  }

  if (user.lastName) {
    data.ln = user.lastName;
  }

  // Only call if we actually have data
  if (Object.keys(data).length > 0) {
    window.fbq("init", PIXEL_ID, data);
  }
};
